<quill-editor
  [placeholder]="placeholder"
  [sanitize]="sanitize"
  [readOnly]="disabled"
  [ngClass]="classes"
  [(ngModel)]="content"
  [modules]="editorModules"
  (onContentChanged)="onContentChanged($event)"
>
  <div quill-editor-toolbar>
    <span class="ql-formats">
      <button class="ql-bold" [title]="'Gras'"></button>
      <button class="ql-italic" [title]="'Italique'"></button>
      <button class="ql-underline" [title]="'Souligné'"></button>
      <button class="ql-strike" [title]="'Barré'"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered" [title]="'Numérotations'"></button>
      <button class="ql-list" value="bullet" [title]="'Puces'"></button>
      <select class="ql-align" [title]="'Aligner'">
        <option selected>Aligner à gauche</option>
        <option value="center">Centrer</option>
        <option value="right">Aligner à droite</option>
        <option value="justify">Justifier</option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-indent" value="-1" [title]="'Diminuer le retrait'"></button>
      <button class="ql-indent" value="+1" [title]="'Augmenter le retrait'"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-direction" value="rtl" [title]="'De droite à gauche'"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-size" [title]="'Taille'">
        <option value="small">Petite</option>
        <option selected>Normale</option>
        <option value="large">Grande</option>
        <option value="huge">Très grande</option>
      </select>
    </span>
    <span class="ql-formats">
      <select class="ql-font" [title]="'Police'">
        <option selected value="arialblack">Arial</option>
        <option value="garamond">Garamond</option>
        <option value="georgia">Georgia</option>
        <option value="monospace">Monospace</option>
        <option value="sans-serif">Sans serif</option>
        <option value="serif">Serif</option>
        <option value="tahoma">Tahoma</option>
        <option value="times new roman">Times New Roman</option>
        <option value="trebuchet ms">Trebuchet MS</option>
        <option value="verdana">Verdana</option>
      </select>
    </span>
    <span class="ql-formats">
      <select class="ql-color" [title]="'Couleur de la police'"></select>
      <select class="ql-background" [title]="'Mettre en surbrillance'"></select>
    </span>
    <span class="ql-formats">
      <button class="ql-link" [title]="'Insérer un lien'"></button>
      <button class="ql-image" [title]="'Insérer une image'"></button>
      <button class="ql-video" [title]="'Insérer une vidéo'"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-clean" [title]="'Supprimer la mise en forme'"></button>
    </span>
  </div>
</quill-editor>
